import React from 'react';
import './customNotification.css';
import cx from "classnames";

interface props {
    type?: string
    title?: string
    message?: string
}

const CustomNoti: React.FC<props> = ({ type, title, message }) => {

    return <div className={cx("nofiFication", type)}>
        <div className='notiHeader'><b>{title}</b></div>
        {message && <div className='notiBody' dangerouslySetInnerHTML={{ __html: message }}></div>}
    </div>
}
export default CustomNoti;